import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const ComplianceHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2} sx={{ height: '100%' }}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Compliance Management
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Ensure your hiring process complies with relevant laws and regulations.
          Manage documentation, track requirements, and maintain audit trails.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Document Retention
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Configure document retention policies and schedules. Automatically archive
          or delete documents according to compliance requirements.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Audit Trails
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Maintain detailed audit trails of all hiring activities. Track changes,
          approvals, and system access for compliance reporting.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Compliance Reporting
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Generate compliance reports for EEOC, OFCCP, and other regulatory requirements.
          Track diversity metrics and hiring statistics.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Data Privacy
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Manage candidate data privacy in accordance with GDPR, CCPA, and other
          data protection regulations. Configure data retention and deletion policies.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/settings/compliance"
            color="primary"
            variant="contained"
          >
            Configure Compliance Settings
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default ComplianceHelp; 